var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloudServer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#0069FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8108 32.2942C17.8108 32.9222 18.3198 33.4309 18.9475 33.4309C19.5752 33.4309 20.0842 32.9222 20.0842 32.2942",
    fill: "white",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0842 39.1144C20.0842 39.7424 19.5752 40.2511 18.9475 40.2511C18.3198 40.2511 17.8108 39.7424 17.8108 39.1144C17.8108 38.4866 18.3198 37.9777 18.9475 37.9777C19.5752 37.9777 20.0842 38.4866 20.0842 39.1144Z",
    fill: "white",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2499 25.4739C42.2491 29.0192 39.5311 31.9719 35.9981 32.2658L15.5375 32.2941C13.8791 32.2952 12.2884 31.6367 11.1159 30.4642C9.94308 29.2914 9.28481 27.7007 9.28565 26.0423C9.28565 23.2233 11.1497 21.4103 13.7131 20.626C13.4148 19.8123 13.2627 18.952 13.2641 18.0854C13.2655 16.2613 14.3564 14.6142 16.0354 13.901C17.7143 13.1878 19.6569 13.5463 20.971 14.8118C22.1304 10.9932 26.1127 8.78529 29.9655 9.82486C33.8185 10.8647 36.1496 14.776 35.2308 18.6595C35.299 18.6537 35.3615 18.6537 35.4297 18.6537C39.1964 18.6537 42.2499 21.7072 42.2499 25.4739Z",
    fill: "white",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9979 28.3157H15.5374V22.6322H35.9979V28.3157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0842 25.474C20.0842 26.102 19.5752 26.6107 18.9475 26.6107C18.3198 26.6107 17.8108 26.102 17.8108 25.474C17.8108 24.8462 18.3198 24.3373 18.9475 24.3373C19.5752 24.3373 20.0842 24.8462 20.0842 25.474Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9979 35.1359H15.5374V29.4524H35.9979V35.1359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0842 32.2942C20.0842 32.9222 19.5752 33.4309 18.9475 33.4309C18.3198 33.4309 17.8108 32.9222 17.8108 32.2942C17.8108 31.6664 18.3198 31.1575 18.9475 31.1575C19.5752 31.1575 20.0842 31.6664 20.0842 32.2942Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9979 41.9561H15.5374V36.2726H35.9979V41.9561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0842 39.1144C20.0842 39.7424 19.5752 40.2511 18.9475 40.2511C18.3198 40.2511 17.8108 39.7424 17.8108 39.1144C17.8108 38.4866 18.3198 37.9777 18.9475 37.9777C19.5752 37.9777 20.0842 38.4866 20.0842 39.1144Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1562 23.7689H34.293V24.9056H33.1562V23.7689Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8828 23.7689H32.0195V24.9056H30.8828V23.7689Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6094 23.7689H29.7461V24.9056H28.6094V23.7689Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3359 23.7689H27.4726V24.9056H26.3359V23.7689Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 23.7689H25.1992V24.9056H24.0625V23.7689Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1562 26.0424H34.293V27.1791H33.1562V26.0424Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8828 26.0424H32.0195V27.1791H30.8828V26.0424Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6094 26.0424H29.7461V27.1791H28.6094V26.0424Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3359 26.0424H27.4726V27.1791H26.3359V26.0424Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 26.0424H25.1992V27.1791H24.0625V26.0424Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7893 23.7689H22.926V24.9056H21.7893V23.7689Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7893 26.0424H22.926V27.1791H21.7893V26.0424Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1562 30.5891H34.293V31.7258H33.1562V30.5891Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8828 30.5891H32.0195V31.7258H30.8828V30.5891Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6094 30.5891H29.7461V31.7258H28.6094V30.5891Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3359 30.5891H27.4726V31.7258H26.3359V30.5891Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 30.5891H25.1992V31.7258H24.0625V30.5891Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1562 32.8625H34.293V33.9992H33.1562V32.8625Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8828 32.8625H32.0195V33.9992H30.8828V32.8625Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6094 32.8625H29.7461V33.9992H28.6094V32.8625Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3359 32.8625H27.4726V33.9992H26.3359V32.8625Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 32.8625H25.1992V33.9992H24.0625V32.8625Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7893 30.5891H22.926V31.7258H21.7893V30.5891Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7893 32.8625H22.926V33.9992H21.7893V32.8625Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1562 37.4093H34.293V38.546H33.1562V37.4093Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8828 37.4093H32.0195V38.546H30.8828V37.4093Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6094 37.4093H29.7461V38.546H28.6094V37.4093Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3359 37.4093H27.4726V38.546H26.3359V37.4093Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 37.4093H25.1992V38.546H24.0625V37.4093Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1562 39.6827H34.293V40.8194H33.1562V39.6827Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8828 39.6827H32.0195V40.8194H30.8828V39.6827Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6094 39.6827H29.7461V40.8194H28.6094V39.6827Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3359 39.6827H27.4726V40.8194H26.3359V39.6827Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 39.6827H25.1992V40.8194H24.0625V39.6827Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7893 37.4093H22.926V38.546H21.7893V37.4093Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7893 39.6827H22.926V40.8194H21.7893V39.6827Z",
    fill: "#0069FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.9643,
    height: 32.9643,
    fill: "white",
    transform: "translate(9.28564 9.28571)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloudServer);
export default __webpack_public_path__ + "static/media/icon-cloud_server.ce1572d075c0bc4d7f65541b807f9f5e.svg";
export { ForwardRef as ReactComponent };